import { render, staticRenderFns } from "./Side.vue?vue&type=template&id=2a388e34&"
import script from "./Side.vue?vue&type=script&lang=js&"
export * from "./Side.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a388e34')) {
      api.createRecord('2a388e34', component.options)
    } else {
      api.reload('2a388e34', component.options)
    }
    module.hot.accept("./Side.vue?vue&type=template&id=2a388e34&", function () {
      api.rerender('2a388e34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Calculators/KeyPlan/Summaries/Side.vue"
export default component.exports